export default __webpack_public_path__ + "static/media/ideal_installment.c2065b11.png";